import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import OurWork from './pages/OurWork';
import Contact from './pages/Contact';
import ServiceDetail from './pages/ServiceDetail';
import SearchResults from './pages/SearchResults';
import NotFound from './pages/NotFound';
import Founder from './pages/Founder';
import Vacancies from './pages/Vacancies';
import ReactGA from "react-ga4";
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    ReactGA.initialize("G-XCWZ28HXJ8")
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "App.tsx" });
  }, [])
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="founder" element={<Founder />} />
          <Route path="services" element={<Services />} />
          <Route path="services/:serviceId" element={<ServiceDetail />} />
          <Route path="our-work" element={<OurWork />} />
          <Route path="search" element={<SearchResults />} />
          <Route path="contact" element={<Contact />} />
          <Route path="vacancies" element={<Vacancies />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App
